<template>
  <div>
    <p class="has-text-weight-bold is-size-4">
      {{ $t("mp:applications.title") }}
    </p>

    <template v-if="loaded">
      <FieldListing
        :data="applications"
        :columns="tableColumns"
        :actions="actions"
        :searchable="true"
        :paginated="true"
        default-sort="created"
        store-fetch-command="applicationAdmin/fetchList"
        store-get-command="applicationAdmin/getList"
        :search-fields="searchFields"
      />
    </template>

    <LoadingSkeleton v-else />
  </div>
</template>

<script>
import LoadingSkeleton from "../components/LoadingSkeleton";
import FieldListing from "../components/FieldListing";
import {
  MERCHANT_APPLICATION_STATUS,
  SEARCH_FIELD_TYPES,
} from "../utils/const";
import { formatBooleanRow } from "../utils/util";
import { AUTHORITIES } from "../utils/authorities";
import i18n from "../plugins/i18n";

export default {
  name: "Applications",
  title: "mp:page.applications.title",
  components: {
    FieldListing,
    LoadingSkeleton,
  },
  async mounted() {
    await this.fetch();
    this.loaded = true;
  },
  data() {
    return {
      loaded: false,
      applications: [],
      searchFields: [
        {
          name: "mp:applications.list_header.id",
          identifier: "id",
          type: SEARCH_FIELD_TYPES.LONG,
          genericSearch: true,
        },
        {
          name: "mp:applications.list_header.flow_name",
          identifier: "flowName",
          type: SEARCH_FIELD_TYPES.TEXT,
          genericSearch: true,
        },
        {
          name: "mp:applications.list_header.current_status",
          identifier: "currentStatus",
          type: SEARCH_FIELD_TYPES.ENUM,
          values: MERCHANT_APPLICATION_STATUS.TOKEN,
          genericSearch: true,
        },
        {
          name: "mp:applications.list_header.created",
          identifier: "created",
          type: SEARCH_FIELD_TYPES.DATETIME,
          genericSearch: false,
        },
        {
          name: "mp:applications.list_header.active",
          identifier: "active",
          type: SEARCH_FIELD_TYPES.BOOLEAN,
          genericSearch: false,
        },
      ],
      tableColumns: [
        {
          field: "id",
          label: "mp:applications.list_header.id",
          format: (row) => {
            return row.id;
          },
        },
        {
          field: "flowName",
          label: "mp:applications.list_header.flow_name",
          format: (row) => {
            return row.flowName;
          },
        },
        {
          field: "currentStatus",
          label: "mp:applications.list_header.current_status",
          format: (row) => {
            return i18n.t(MERCHANT_APPLICATION_STATUS.TOKEN[row.currentStatus]);
          },
        },
        {
          field: "created",
          label: "mp:applications.list_header.created",
          format: (row) => {
            return this.$options.filters.dateTime(row.created);
          },
        },
        {
          field: "active",
          label: "mp:applications.list_header.active",
          vhtml: true,
          format: (row) => {
            return formatBooleanRow(row.active);
          },
        },
      ],
      actions: [
        {
          icon: "chevron-right",
          iconPack: "fa",
          type: "is-grey-icon",
          disabled: () => {
            return !this.canSeeDetails;
          },
          function: (row) => {
            this.$router.push({
              name: "ApplicationDetails",
              params: {
                id: row.id,
              },
            });
          },
        },
      ],
    };
  },
  computed: {
    canSeeDetails() {
      return this.$store.getters["session/hasAnyAuthority"]([
        AUTHORITIES.APPLICATION.GET,
        AUTHORITIES.APPLICATION.ADMIN,
      ]);
    },
  },
  methods: {
    async fetch() {
      await this.$store.dispatch(
        "applicationAdmin/fetchList",
        "sort=created,desc"
      );
      this.applications = this.$store.getters["applicationAdmin/getList"];
    },
  },
};
</script>
